// extracted by mini-css-extract-plugin
module.exports =  {"popover":"gUGgmNSfyDz0UR0o57RC","info":"KlYZkRcQJ7VUkbLS1dNE"};